import React from 'react';
import { Trans } from '@lingui/react';

import SelectedPropertyItem from './SelectedPropertyItem';

const SelectedPropertiesList = ({ properties, getLabel, onRemove, removeTitle, emptyMessageId = 'profiles:rules:no_properties_selected' }) => {
    if (properties.length === 0) {
        return (
            <div className="text-gray text-center p-4">
                <Trans id={emptyMessageId} />
            </div>
        );
    }

    return (
        <div>
            {properties.map((property) => (
                <SelectedPropertyItem
                    key={property}
                    label={getLabel(property)}
                    onRemove={() => onRemove(property)}
                    removeTitle={removeTitle}
                />
            ))}
        </div>
    );
};

export default SelectedPropertiesList;